export type HerstellerLogo = {
	src: string;
	title: string;
	ariaLabel: string;
};

export const images: HerstellerLogo[] = [
	{
		src: '/img/hersteller-logos/widex-logo.webp',
		title: 'Widex Logo',
		ariaLabel: 'Logo von Widex',
	},
	{
		src: '/img/hersteller-logos/signia-logo.webp',
		title: 'Signia Logo',
		ariaLabel: 'Logo von Signia',
	},
	{
		src: '/img/hersteller-logos/logo-hoerluchs.webp',
		title: 'Hörluchs Logo',
		ariaLabel: 'Logo von Hörluchs',
	},
	{
		src: '/img/hersteller-logos/resound-seeklogo.webp',
		title: 'ReSound Logo',
		ariaLabel: 'Logo von ReSound',
	},
	{
		src: '/img/hersteller-logos/audio-service-logo.webp',
		title: 'Audio Service Logo',
		ariaLabel: 'Logo von Audio Service',
	},
	{
		src: '/img/hersteller-logos/phonak-logo.webp',
		title: 'Phonak Logo',
		ariaLabel: 'Logo von Phonak',
	},
	{
		src: '/img/hersteller-logos/oticon-logo.webp',
		title: 'Oticon Logo',
		ariaLabel: 'Logo von Oticon',
	},
	{
		src: '/img/hersteller-logos/bernafon-logo.webp',
		title: 'Bernafon Logo',
		ariaLabel: 'Logo von Bernafon',
	},
	{
		src: '/img/hersteller-logos/sonic-logo.webp',
		title: 'Sonic Logo',
		ariaLabel: 'Logo von Sonic',
	},
	{
		src: '/img/hersteller-logos/unitron-logo.webp',
		title: 'Unitron Logo',
		ariaLabel: 'Logo von Unitron',
	},
];
